module.exports = __webpack_public_path__ + "media/images/company-logos/bern-logo-705cfa5a06c8cac8012d32b0d018deb6.jpg";